import React from 'react'
import classnames from 'classnames/bind'
import type { ShallowTaskWorkflowMilestone } from '@adc/sdk/types'
import { ColorNames } from '../../constants'
import { formatEnum } from '../../utils/formatters'
import Text from '../elementals/text'
import InfoPill from '../elementals/infoPill'
// @ts-ignore
import styles from './styles.scss'

const cx = classnames.bind(styles)

const getMilestoneStatus = (offerWorkflowStatus: String, code: string) => {
  const formattedStatus = formatEnum(offerWorkflowStatus)

  const mappings: Record<string, React.ReactNode> = {
    CLOSING_SCHEDULED: (
      <InfoPill
        content={formattedStatus}
        backgroundColor={ColorNames.CautionLight}
        foregroundColor={ColorNames.Caution}
        includeBorder
        className={cx('milestone-closing-status')}
      />
    ),
  }

  return mappings[code] || null
}

interface MilestoneLabelProps {
  milestone: ShallowTaskWorkflowMilestone
  offerWorkflowStatus: String
  elmId?: string
}

const MilestoneLabel: React.FC<MilestoneLabelProps> = ({
  milestone,
  offerWorkflowStatus,
  elmId = 'milestone_label',
}) => {
  return (
    <div key={`${elmId}_${milestone?.code}`} className={cx('milestone-label')}>
      <Text size='small' weight='heavy' className={cx('milestone-title')}>
        {milestone?.label}
      </Text>
      {getMilestoneStatus(offerWorkflowStatus, milestone?.code)}
    </div>
  )
}

export default MilestoneLabel
